// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".counter[data-v-031139ea]{display:flex}.counter__status[data-v-031139ea]{font-weight:400;font-size:14px;text-transform:uppercase}", ""]);
// Exports
module.exports = exports;
